import { ClockIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { type JSX } from "react";

interface BannerPreviewProps {
  primaryMessage: string;
  secondaryMessage: string;
}

export default function BannerPreview({
  primaryMessage,
  secondaryMessage,
}: BannerPreviewProps): JSX.Element {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-700 mb-2">Preview</h3>
      <div className="flex items-center gap-x-2 rounded-md bg-amber-50 border border-amber-200 px-3 py-1.5 w-fit">
        <ClockIcon
          className="h-4 w-4 text-amber-600 flex-shrink-0"
          aria-hidden="true"
        />
        <div className="flex flex-col text-left">
          <p
            className="text-xs font-semibold text-amber-800 leading-tight whitespace-nowrap"
            title={primaryMessage || "Your primary message will appear here."}>
            {primaryMessage || "Your primary message will appear here."}
          </p>
          {(secondaryMessage || !primaryMessage) && (
            <p
              className="text-xs text-amber-700 leading-tight whitespace-nowrap"
              title={
                secondaryMessage || "Your secondary message will appear here."
              }>
              {secondaryMessage || "Your secondary message will appear here."}
            </p>
          )}
        </div>
        <button
          type="button"
          disabled
          className="flex-shrink-0 rounded p-0.5 text-amber-600 hover:bg-amber-100 hover:text-amber-800 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Dismiss banner (preview only, non-functional)">
          <span className="sr-only">Dismiss</span>
          <XMarkIcon className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
      <p className="mt-3 text-xs text-gray-500 italic">
        Preview only — not visible until saved and enabled.
      </p>
    </div>
  );
}
